import { render, staticRenderFns } from "./NewToast.vue?vue&type=template&id=28518482&scoped=true"
import script from "./NewToast.vue?vue&type=script&lang=js"
export * from "./NewToast.vue?vue&type=script&lang=js"
import style0 from "./NewToast.vue?vue&type=style&index=0&id=28518482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28518482",
  null
  
)

export default component.exports